var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-loader"},[_c('i',{staticClass:"fal fa-circle-notch fa-spin",attrs:{"aria-hidden":"true"}}),_vm._v(" Loading\n")])
}]

export { render, staticRenderFns }